import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Person } from '../person/model/person';
import { PersonnameService } from './service/personname.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { PersonOrganization } from '@src/app/models/personorganization';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-personname',
  templateUrl: './personname.component.html',
  styleUrls: ['./personname.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonnameComponent implements OnInit, OnChanges {
  @Input() personId: string;
  @Input() @Output() enableChange: boolean;
  @Input() chatType: boolean;
  @Input() creatorstage: string;
  @Input() viewtypeshort: boolean;
  @Input() spacing: boolean;
  @Input() viewtypeportal: boolean;
  @Input() widthpne: string;

  person: Person;
  member: PersonOrganization
  show: boolean;
  pnestyle: { [key: string]: string };
  constructor(private pnsrv: PersonnameService, private datastore: DatastoreService, private uieventhub: UieventhubService) { }

  ngOnInit() {
    let width = Number(this.widthpne) - 20;
    this.pnestyle = { 'width': width + 'px' };
    this.show = false;
    this.person = new Person;
    if (this.personId && (this.personId.substr(0, 7) === 'roleId_' || this.personId == 'customertemplate')) {
      this.person.fullname = "Role from template";
      this.person.phone = "Not set";
      this.person.im = "Not set";
      this.person.email = "Not set";
    } else {
      if (this.personId) {
        //get person list from datastore
        // if(this.datastore.getPersonOrganizations() && this.datastore.getPersonOrganizations().length > 0){
        this.member = this.datastore.orgMembers.getValue().find(person => person.personId == this.personId);
        if (this.member) {
          this.person = new Person;
          this.person.fullname = this.member.membername;
          this.person.phone = this.member.phone;
          this.person.im = this.member.im;
          this.person.email = this.member.email;
        } else {
          //try get from customer users
          let custusr = this.datastore.customersUsers.getValue().find(person => person.userId.split('_')[0] == this.personId);
          if (custusr) {
            this.member = new PersonOrganization;
            this.member.personId = custusr.userId;
            this.member.membername = custusr.fullname;
            this.member.phone = custusr.phone;
            this.member.email = custusr.email;

            //console.log('custusr',custusr);
            this.person = new Person;
            this.person.fullname = custusr.fullname;
            this.person.phone = custusr.phone;
            this.person.email = custusr.email;
          }
        }
        // }


        // if(sessionStorage.getItem('person_'+this.personId)){
        //   this.person = JSON.parse(sessionStorage.getItem('person_'+this.personId));

        // }else{
        // this.pnsrv.getPerson(this.personId).pipe(untilDestroyed(this)).subscribe(person =>{
        //   this.person = person;
        //   sessionStorage.setItem('person_'+this.personId,JSON.stringify(this.person))
        // });
        //}
      } else {
        this.person.fullname = "Not set";
        this.person.phone = "Not set";
        this.person.im = "Not set";
        this.person.email = "Not set";
      }

    }

  }
  ngAfterViewInit() {
    //console.log('after view init from personame');
    this.uieventhub.removeLoader('personname');
    this.uieventhub.removeLoader('portal');
    this.uieventhub.removeLoader('projectlist');
    this.uieventhub.removeLoader('projectportal_tasks');
    this.uieventhub.removeLoader('projectportal_stages');
    this.uieventhub.removeLoader('projectportal');
    this.uieventhub.removeLoader('project');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.widthpne && changes.widthpne.currentValue && this.pnestyle) {
      let width = changes.widthpne.currentValue - 20;
      this.pnestyle['width'] = width + 'px';
      // const boxes = Array.from(
      //   document.getElementsByClassName('box') as HTMLCollectionOf<HTMLElement>,
      // );
      // boxes.forEach(box => {
      //console.log('from personame',this.widthpne)
      //   box.style.width = this.widthpne + 'px';
      // });

    }
    if (changes.personId && changes.personId.currentValue) {
      //this.uieventhub.addLoader('personname');
      if (changes.personId.currentValue.substr(0, 7) == 'roleId_' || changes.personId.currentValue == 'customertemplate') {
        this.person = new Person;
        this.person.fullname = "Role from template";
        this.person.phone = "Not set";
        this.person.im = "Not set";
        this.person.email = "Not set";

      } else {
        if (sessionStorage.getItem('person_' + this.personId)) {
          this.person = JSON.parse(sessionStorage.getItem('person_' + this.personId));

        } else {
          // this.pnsrv.getPerson(this.personId).pipe(untilDestroyed(this)).subscribe(person =>{
          //   this.person = person;
          //   sessionStorage.setItem('person_'+this.personId,JSON.stringify(this.person))
          // });
          this.member = this.datastore.orgMembers.getValue().find(person => person.personId == this.personId);
          if (this.member) {
            this.person = new Person;
            this.person.fullname = this.member.membername;
            this.person.phone = this.member.phone;
            this.person.im = this.member.im;
            this.person.email = this.member.email;
          } else {
            //try get from customer users
            //console.log('custusr',this.datastore.customersUsers.getValue());
            let custusr = this.datastore.customersUsers.getValue().find(person => person.userId.split('_')[0] == this.personId);
            if (custusr) {
              this.member = new PersonOrganization;
              this.member.personId = custusr.userId;
              this.member.membername = custusr.fullname;
              this.member.phone = custusr.phone;
              this.member.email = custusr.email;
              //console.log('custusr',custusr);
              this.person = new Person;
              this.person.fullname = custusr.fullname;
              this.person.phone = custusr.phone;
              this.person.email = custusr.email;
            }
          }
        }
      }
    }
  }
  toggleCard() {
    this.show = !this.show;
  }


}
